import { getAddressString } from "@msuite/utils/strings";
import type { ProjectCard as ProjectCardType } from "@msuite/utils/types";

/** Props Interface */
interface ProjectCardCompactProps {
	project: Omit<ProjectCardType, "_tickets" | "createdAt" | "updatedAt"> & {
		createdAt: string | number | null;
		updatedAt: string | number | null;
	};
}

export function ProjectCardCompact({ project }: ProjectCardCompactProps) {
	return (
		<div className="v-stack gap-1">
			<p>{project.number}</p>
			<p>{project.name}</p>
			<p>{getAddressString(project)}</p>
		</div>
	);
}
